import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrow = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 58,
	height: 43,
	viewBox: "0 0 58 43",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M46.3934 18.4049L30.3554 3.83957L34.5832 0L57.8389 21.1203L34.5832 42.2407L30.3554 38.4011L46.3934 23.8357H0V18.4049H46.3934Z",
		fill: "#181818"
	})]
});
const ForwardRef = forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
